<template>
  <article>
    <h1 class="sr-only">Charge On</h1>
    <Hero :bgColor="false">
      <template slot="image">
        <img
          v-if="!isPhone"
          src="@/assets/images/ChargeOn/hero-desktop.png"
          alt="Charge On - Built by us, powered by you."
        />
        <img
          v-if="isPhone"
          src="@/assets/images/ChargeOn/hero-mobile.png"
          alt="Charge On - Built by us, powered by you."
        />
      </template>
    </Hero>
    <div class="center-column">
      <p class="moderate-padding">
        Electrify America was built for the future of driving - and for those who never stop exploring. We keep drivers
        moving with a fast, seamless charging experience that powers every adventure behind the wheel.
      </p>
      <h2>Share Your Story With Us!</h2>
    </div>
    <div class="column">
      <div class="moderate-padding">
        <iframe
          class="responsive-iframe"
          title="vimeo-player"
          src="https://player.vimeo.com/video/1146000545?h=68f87feb03"
          frameborder="0"
          referrerpolicy="strict-origin-when-cross-origin"
          allow="autoplay; fullscreen; picture-in-picture; clipboard-write; encrypted-media; web-share"
          allowfullscreen
        ></iframe>
      </div>
      <h2>Need Inspiration?</h2>
      <p>
        We love photos of our chargers, but what we really want to see is YOU - the things you do, and the people or
        pets you do it with, everything that helps you <strong>#ChargeOn</strong>.
      </p>
      <p>Show us how EV charging supports your daily adventures - big or small!</p>
      <h4>Things to Avoid</h4>
      <ul>
        <li>Inappropriate or illegal objects and behaviors</li>
        <li>Minors</li>
      </ul>
    </div>
    <div class="center-column-wide moderate-padding">
      <h2>Got a Moment in Mind? Send it Our Way -</h2>
      <br />
      <h2>Just Fill Out the Form Below</h2>
    </div>
    <div class="column">
      <div class="form-styler">
        <tint-form team-id="501165" form-id="2969"></tint-form>
      </div>
      <p>
        If you are having issues viewing the submission form, please submit via
        <a class="link" href="https://www.eachargeon.com/" target="_blank">this page</a>.
      </p>
    </div>
  </article>
</template>

<script>
import Hero from '../components/Hero/Hero.vue';

export default {
  name: 'charge-on',
  metaInfo: {
    title: 'Charge On | Electrify America',
  },
  components: { Hero },
  computed: {
    isPhone() {
      return this.$resize && this.$mq.below(749);
    },
  },
  methods: {
    getUTMParameters() {
      const urlParams = new URLSearchParams(window.location.search);
      const utmParams = {};
      ['utm_source', 'utm_medium', 'utm_campaign'].forEach((param) => {
        if (urlParams.has(param)) {
          utmParams[param] = urlParams.get(param);
        }
      });
      return utmParams;
    },
  },
  mounted() {
    const script = document.createElement('script');
    script.setAttribute('src', 'https://advocacy.trueloyal.com/dist/tint.js');
    script.setAttribute('async', 'true');

    document.head.appendChild(script);
    const urlParams = new URLSearchParams(window.location.search);
    const targetParams = ['utm_campaign', 'utm_source', 'utm_medium', 'utm_content', 'utm_term'];

    // The form may not load immediately
    const formCheckInterval = setInterval(() => {
      const shadowHost = document.querySelector('tint-form div');

      if (shadowHost && shadowHost.shadowRoot) {
        const { shadowRoot } = shadowHost;

        targetParams.forEach((param) => {
          if (urlParams.has(param)) {
            const input = shadowRoot.querySelector(`input[name="${param}"]`);

            if (input) {
              input.value = urlParams.get(param);

              // Dispatch change events to ensure the component registers the new state
              input.dispatchEvent(new Event('input', { bubbles: true, composed: true }));
              input.dispatchEvent(new Event('change', { bubbles: true, composed: true }));
            }
          }
        });
      }
    }, 500);

    // Safety timeout: stop looking after 5 seconds.
    // We also need to add the GTM datalayer push a single time on submit. Might as well do it here.
    // The user shouldnt be able to finish the form before 5 seconds, and if its gonna render it will have by now
    setTimeout(() => {
      clearInterval(formCheckInterval);
      document.querySelector('tint-form')?.addEventListener('afterSubmit', (e) => {
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
          event: 'tint_form_submit',
          formId: '2969',
          submission: e.detail,
        });
      });
    }, 5000);
  },
};
</script>
<style lang="scss" scoped>
.column {
  max-width: 1200px;
  margin: auto;
  padding-left: 20px;
  padding-right: 20px;
}
.center-column {
  margin: auto;
  padding-left: 20px;
  padding-right: 20px;
  p {
    font-size: large;
  }
  max-width: 800px;
  text-align: center;
  h2 {
    font-size: xxx-large;
    @media (max-width: 750px) {
      font-size: xx-large;
    }
  }
}
.center-column-wide {
  margin: auto;
  p {
    font-size: large;
  }
  max-width: 1000px;
  text-align: center;
  h2 {
    font-size: xxx-large;
    @media (max-width: 750px) {
      font-size: xx-large;
    }
  }
}

.form-styler {
  background-color: $c-primary-light;
}
.moderate-padding {
  padding-top: 50px;
  padding-bottom: 50px;
}
.responsive-iframe {
  width: 100%;
  height: auto;
  aspect-ratio: 16 / 9;

  // Removes any default inline-block spacing
  display: block;

  @media (min-width: 800px) {
    padding-bottom: 30px;
  }
}
h2 {
  line-height: 3rem;
}
</style>
